import { useCallback, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { ChevronLeft, Radio } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { DataTable } from '@/components/DataTable'
import type { AdminColumn } from '@/components/DataTable/types'
import { PERMISSIONS } from '@/lib/permissions'
import { fetchOperators, GEO_STR as S, type OperatorRow } from './geoApi'

/**
 * A11.10 — Telefon operatorlari. MCC/MNC bo'yicha operator ma'lumotnomasi
 * (OTP yo'naltirish). Greenfield `/admin/geo/operators` → fetcher fail-soft
 * bo'sh; backend chiqqanda to'ladi (devApi.ts naqshi).
 */
export function PhoneOperatorsScreen() {
  const columns = useMemo<AdminColumn<OperatorRow>[]>(
    () => [
      { key: 'country_code', header: S.code, type: 'id', width: 80 },
      { key: 'name', header: S.operator, type: 'text', minWidth: 180 },
      {
        key: 'mcc_mnc',
        header: S.mccMnc,
        type: 'text',
        width: 120,
        render: (r) => <span className="font-mono tabular text-primary">{r.mcc_mnc}</span>,
      },
      { key: 'subscribers', header: S.subscribers, type: 'number', width: 120, align: 'right' },
      {
        key: 'status',
        header: S.status,
        type: 'enum',
        width: 120,
        options: [
          { value: 'active', label: S.statusActive, status: 'active' },
          { value: 'inactive', label: S.stageClosed, status: 'banned' },
        ],
      },
    ],
    [],
  )

  const fetcher = useCallback(fetchOperators, [])

  return (
    <>
      <PageHeader
        title={S.operatorsTitle}
        screenId="A11.10"
        description={S.operatorsNote}
        actions={
          <Link
            to="/geo"
            className="inline-flex items-center gap-1 rounded-md border border-border-default bg-surface-2 px-2.5 py-1 text-sm text-secondary hover:text-primary"
          >
            <ChevronLeft size={13} />
            {S.backToList}
          </Link>
        }
      />
      <DataTable<OperatorRow>
        screenId="A11.10"
        permission={PERMISSIONS.COUNTRIES_VIEW}
        columns={columns}
        fetcher={fetcher}
        rowId={(r) => String(r.id)}
        exportable
        emptyState={{ icon: <Radio size={28} strokeWidth={1.5} /> }}
      />
    </>
  )
}
